import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { colors } from '@naf-simba/theme';

interface SimpleTextLinkProps {
  href?: string;
  children: ReactNode;
  onClick?: () => void;
}

const SimpleTextLink = ({ href, children, onClick }: SimpleTextLinkProps) => (
  <StyledTextLink href={href} target="_blank" rel="noopener noreferrer" onClick={onClick}>
    {children}
  </StyledTextLink>
);

const StyledTextLink = styled.a`
  cursor: pointer;
  color: ${({ theme }) => (theme?.typography?.textLink ? theme.typography.textLink : `#1a1a1a`)};
  text-decoration: underline;
  &:hover {
    color: ${colors.secondary[500]};
    text-decoration: none;
  }
`;

export default SimpleTextLink;
